export default __webpack_public_path__ + "static/media/mail.0fe04942.svg";